import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CategoriaData {

  constructor(
    private afDatabase: AngularFireDatabase
  ) { }

  getCategories(client: string) {
    return this.afDatabase.list<any>(`/ClientList/${client}/Categorias`).valueChanges();
  }

  changeCategoryName(client: string, category: string, name: string) {
    return this.afDatabase.object<any>(`/ClientList/${client}/Categorias/${category}/name`).set(name);
  }

  deleteCategory(client: string, category: string) {
    return this.afDatabase.object<any>(`/ClientList/${client}/Categorias/${category}`).set(null);
  }

  addCategorie(client: string, data: any) {
    const key = this.afDatabase.createPushId();
    return this.afDatabase.object<any>(`/ClientList/${client}/Categorias/${key}`).set({ ...data, id: key });
  }

  addTags(client: string, category: string, tags: string[]) {
    return this.afDatabase.object<any>(`/ClientList/${client}/Categorias/${category}/tags`).update(tags);
  }

  getCategorieRef(client: string, id: string) {
    return this.afDatabase.object(`/ClientList/${client}/Categorias/${id}`).query.ref;
  }

}


// WEBPACK FOOTER //
// ./src/providers/categoria.ts